import { render, staticRenderFns } from "./ContactsDetail.vue?vue&type=template&id=46813606&scoped=true&lang=pug"
import script from "./ContactsDetail.vue?vue&type=script&lang=js"
export * from "./ContactsDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactsDetail.vue?vue&type=style&index=0&id=46813606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46813606",
  null
  
)

export default component.exports